import { batchDeleteOptions } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { BatchDeleteInput } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

async function batchRemoveOptions(options: BatchDeleteInput[]): Promise<boolean> {
	if (options.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchDeleteOptions,
				variables: { options },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
			return false;
		}
	}
	return true;
}

export default batchRemoveOptions;
